export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Částka"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výsledek"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakce"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obnovit stav"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Užitečné odkazy"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Probíhá"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěch"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selhalo"])}
}